import TelemetrySdk from './telemetrySdk';
import config from '../config';
import { getAccessToken } from '../auth/tokenStorage';
import { parseJwt } from '../auth/jwt';
import { apiRequest, buildApiUrl, getHeaders } from '../utils/api';

const telemetry = new TelemetrySdk();


const apiBaseUrl = config.API_BASE_URL;

// Initialize the telemetry SDK singleton instance
telemetry.initialize({
  apiBaseUrl,
  moduleKey: 'iap_admin',
  getOrgId: () => {
    const isSystemOrg = (id) => {
      if (!id) return false;
      const str = String(id).trim().toLowerCase();
      return str === '00000000-0000-0000-0000-000000000001' || str === '00000000-0000-0000-0000-000000000000';
    };

    try {
      const selectedOrg = localStorage.getItem('selected_organization_id');
      if (selectedOrg && !isSystemOrg(selectedOrg)) return selectedOrg;
    } catch (e) {
      // ignore
    }
    const token = getAccessToken();
    if (!token) return null;
    try {
      const decoded = parseJwt(token);
      const orgId = decoded?.org_id;
      return isSystemOrg(orgId) ? null : (orgId || null);
    } catch (e) {
      return null;
    }
  },
  getUserId: () => {
    const token = getAccessToken();
    if (!token) return null;
    try {
      const decoded = parseJwt(token);
      return decoded?.sub || null;
    } catch (e) {
      return null;
    }
  },
  getSiteCollectionId: () => {
    try {
      // Fetch selected site collection id from local storage if set
      return localStorage.getItem('selected_site_collection_id') || null;
    } catch (e) {
      return null;
    }
  },
  getAuthToken: () => getAccessToken(),
  batchIntervalMs: 30000, // 30 seconds interval
  debug: process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENVIRONMENT === 'development'
});


export const getCaptureRequirements = async (orgId) => {
  if (!orgId) return [];
  try {
    const res = await apiRequest(buildApiUrl(
      `/telemetry/organizations/${orgId}/capture-requirements`
    ), { headers: getHeaders() });
    return res.json();
  } catch (err) {
    console.warn("Failed to fetch capture requirements:", err);
    return [];
  }
};

export default telemetry;
